const state = {
    allNotifications: [],
    newNotifications: [],
    displayedNotifications: [],
    historyNotifications: [],
    isRequesting: false,

}
export default state
